import script from "./AmMultiSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./AmMultiSelect.vue?vue&type=script&setup=true&lang=js"

import "./AmMultiSelect.vue?vue&type=style&index=0&id=3e7c939a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e7c939a"]])

export default __exports__